<template>
	<div 
    class="knd-paragraph paragraph-video-swiper"
  >

    <div class="knd-swiper-container">
  <swiper
    :slidesPerView="1.2"
    :spaceBetween="20"
    :slidesOffsetBefore="0"
    :slidesOffsetAfter="0"
    :breakpoints="{
      '640': {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      '860': {
        slidesPerView: 2.8,
        spaceBetween: 20,
      },
      '1024': {
        slidesPerView: 3.2,
        spaceBetween: 20,
      },
      '1280': {
        slidesPerView: 4.2,
        spaceBetween: 20,
      },      
    }"    
    :grabCursor="true"
    :centeredSlides="true"
    :slideToClickedSlide="true"
    :pagination="{
      dynamicBullets: true,
    }"
    :modules="modules"
    :style="{'--swiper-navigation-color': '#FF5362','--swiper-pagination-color': '#FF5362'}" 
    @swiper="onSwiper"
    @slideChange="onSlideChange"
    class='knd-swiper'
  >

  <swiper-slide 
    class='knd-slide'
    >
    <blockquote class="speech up">
      Swipe naar rechts voor een selectie aan ervaringsverhalen van vrouwen op verschillende locaties
     

      <div class="knd-swipe-right ">
        <svg class="animate-bounce-right" width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="17" cy="17" r="17" fill="white"/>
          <path d="M21.2683 18.4615H8L8 16.5385H21.2683C20.0976 16.0769 19.0699 15.3077 18.1854 14.2308C17.3008 13.1538 16.7675 11.7436 16.5854 10H18.5366C18.7187 11.6154 19.3431 13 20.4098 14.1538C21.5024 15.3077 22.6992 16.1026 24 16.5385V18.4615C22.6992 18.8974 21.5024 19.6923 20.4098 20.8462C19.3431 22 18.7187 23.3846 18.5366 25H16.5854C16.7675 23.2564 17.3008 21.8462 18.1854 20.7692C19.0699 19.6923 20.0976 18.9231 21.2683 18.4615Z" fill="black"/>
          </svg>

      </div>
    </blockquote>

  </swiper-slide>

    <swiper-slide 
      class='knd-slide'
      v-for="(slide, index) in quotes" 
      :key="'article-' + index"
      >
      
      <Speech :slide="slide" />

		</swiper-slide>


  <swiper-slide class='knd-slide'>
    <Speech :slide="featuredMarker" />

  </swiper-slide>

  </swiper>
</div>

	</div>
</template>

<script setup>
  import { defineProps, ref, computed } from "vue";
  import { useStore } from 'vuex';

  // Import Swiper 
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Pagination } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/pagination';

  import Speech from './speech';


  const store = useStore();

  const modules = [Pagination];
  const baseUrl = process.env.VUE_APP_ASSETS;

  const featured = computed(() => store.getters.featured);
  const featuredIndex = computed(() => store.getters.featuredIndex);
  const featuredMarker = computed(() => store.getters.featuredMarker);

  const quotes = computed(() => store.getters.quotes);

  let customSwiper = {};

  store.watch((state, getters) => getters.featured, (a, oldvalue)=>{
    if(!a) return;

    customSwiper.slideTo(a.index);
})

  const onSwiper = (swiper) => {
    customSwiper = swiper;
  };

  const onSlideChange = (e) => {
    let index = customSwiper.activeIndex;
    store.dispatch('updateSwiper', index)
  };


</script>

<style langs="scss">

.knd-swiper {
  --swiper-pagination-color: #FF5362;

  .swiper-pagination.swiper-pagination-bullets {
      top: 20px;
      bottom: inherit;
    }
} 

.knd-swipe-right {
  margin: 20px auto 0;
  text-align: center;;
}
</style>

<style lang="scss" scoped>

	.knd-swiper {
    padding-bottom: 25px;
    padding-top: 20px;

    --speech-bubble: var(--off-white);
    --speech-bubble-active: #FFC5CC;

  }

  .swiper-slide {
    // max-width: 350px;
    font-size: 14px;
    user-select: none;

    .speech-active {
      display: none;
      position: absolute;
      top: -16px;
      left: 20px;
    }

    &.swiper-slide-active {
      .speech-active {
       display: block;
      }

      .speech {
        background:  var( --speech-bubble-active);

      }

      .speech.up::after {
        border-bottom-color: var(--speech-bubble-active);
      }
    }
  }

  .label {
    font-weight: bold;
  }

  .keywords {
    margin-bottom: 1rem;

    .keyword-label {
      font-weight: bold;
      font-size: 14px;
      padding-top: 10px;
      padding-bottom: 5px;
      position: relative;

      &:before {
        content: '';
        position: absolute;
        width: 20px;
        height: 3px;
        background: #000;
        top: 0;
      }
    }

    .keyword {
      margin-right: 1rem;
      padding: 1rem 1rem .5rem 1rem;
      line-height: 1.1;
      margin-bottom: 0.5rem;
    }

    &.keyword-primary {
      display: flex;
      flex-wrap: wrap;
      
      .keyword {
        font-family: var(--font-header);
        background: #FFF;
        border-radius: 4px;
      }
    }

    &.keyword-secondary {
      .keywords {
        list-style-type: disc;
      }

      .keyword {
        // border: 1px solid #000;
        padding: 0 0 0.5rem;
        margin: 0;
      }
    }



  }

  .speech {
  /* (A1) FONT & COLORS */
  font-size: 1.2em;
  color: #000;
  background: var( --speech-bubble);

  /* (A2) DIMENSIONS */
  padding: 30px 20px 20px;
  border-radius: 10px;
  max-width: 600px;
  // transform: translateY(20px);
}


/* (D) POSITION THE CALLOUT */
.speech {
  position: relative;
  margin: 30px 0;
}
.speech::after { position: absolute; }
.speech.up::after {
  top: -15px; left: calc(50% - 15px);
}

/* (B) USE ::AFTER TO CREATE THE "CALLOUT" */
.speech::after {
  display: block; width: 0; content: "";
  border: 15px solid transparent;
}
 
/* (C) "CALLOUT" DIRECTIONS */
.speech.up::after {
  border-bottom-color: var( --speech-bubble);
  border-top: 0;
}

</style>